import { useState } from "react";

export default function LiteYouTube({ videoId, title, onPlay, videoUrl }) {
  const [play, setPlay] = useState(false);

  const handlePlay = () => {
    setPlay(true);
    onPlay?.();
  };

  return (
    <div className="yt-lite" style={{ aspectRatio: "16/9" }}>
      {!play ? (
        <button
          className="yt-lite-thumb"
          onClick={handlePlay}
          aria-label="Play video"
        >
          <img
            src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
            alt={title}
            loading="lazy"
          />
          <span className="yt-play-btn" />
        </button>
      ) : (
        <iframe
          width="560"
          height="315"
          src={videoUrl}
          title={title || `video-${videoId}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
          referrerpolicy="strict-origin-when-cross-origin"
        />
      )}
    </div>
  );
}
